import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ukgu0kbkf: FaireProductEntity = {
  token: "p_9ukgu0kbkf",
  type: "product",
  name: "Beachwood Bulk Bag (5lb)",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/a71c1ee188800d106eff86f58e9239e969d712b0ec833670855ffcb089aad60d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6799121ce5ad307f2dd9ed94b0c060187e2ee9c63a1404f6ef6f179a4ef9e1f0.jpeg"
  ],
  priceDollars: 68.2,
  description: "Beachwood will always champion the style of cup we sought to create when starting Canyon—smooth, balanced, and caramelly. A coffee that's easy to brew at home and hits the spot, every morning. We rotate the origin seasonally, to showcase the coffee at its best.\n\n• Origin: Mexico\n• Region: San Agustín Loxicha, indigenous Zapotec community in the state of Oaxaca\n• Producer: UNECAFE S.C\n• Process: Washed\n• Certification: Organic\n• We Taste: Caramel, milk chocolate, & orange peel\n\n𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞:\nBeachwood holds a lot of meaning to us. The name comes from Beachwood Canyon in Los Angeles, the canyon where we—Ally and Casey—met back in 2013.\n\nOur goal is for Beachwood to be a showcase for fresh, seasonal coffees that we can talk about through story. This coffee is also our go-to for espresso, and we roast it with ample development time for ease of extraction and an espresso that tastes great black.",
  tags: [],
  msrpDollars: 136.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:45.830Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
